export enum Stage {
  alpha = 'alpha',
  beta = 'beta',
  dev = 'dev',
  localdev = 'localdev',
  prod = 'prod',
  qa = 'qa',
  sandbox = 'sandbox',
  staging = 'staging',
  test = 'test',
}
